"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var FlagAU = function FlagAU(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "411.6",
    height: "270.36",
    viewBox: "0 0 411.6 270.36"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M209.54,146.36H-185.94A7.07,7.07,0,0,1-193,139.3V-114.94a7.06,7.06,0,0,1,7.06-7.06H209.54a7.06,7.06,0,0,1,7.06,7.06V139.3a7.06,7.06,0,0,1-7.06,7.06Zm0,0",
    transform: "translate(194 123)",
    fill: "#41479b"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M4.74-122H-7.53L-72.95-79.14V-122h-35.31v42.86L-173.67-122h-12.27a7.06,7.06,0,0,0-7.06,7.06v5.6l56.12,36.77H-193v35.32h56.12L-193-.49V5.12a7.06,7.06,0,0,0,7.06,7.06h12.27l65.42-42.86V12.18h35.3V-30.68L-7.53,12.18H4.74A7.06,7.06,0,0,0,11.8,5.12V-.49L-44.32-37.25H11.8V-72.57H-44.32L11.8-109.34v-5.6A7.06,7.06,0,0,0,4.74-122Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M11.8-65.5H-80V-122h-21.18v56.5H-193v21.18h91.81v56.5H-80v-56.5H11.8Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-115.32-72.57l-74.31-48.24a7,7,0,0,0-3.37,5.87v.37l64.71,42Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-60-72.57l70.7-45.89a7,7,0,0,0-6-3.54H3.21L-72.95-72.57Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-121.42-37.25-192,8.55a7,7,0,0,0,6,3.63h1.33l76.16-49.43Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M11.69,5.67-54.45-37.25h-13L7.68,11.49a7,7,0,0,0,4-5.82Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-88.47,50.68l5.34,17.6L-66,61.48a1.58,1.58,0,0,1,1.89,2.37L-74.59,79l16,9.11a1.58,1.58,0,0,1-.67,3l-18.34,1.28,2.83,18.17a1.58,1.58,0,0,1-2.73,1.32L-90,98.28l-12.44,13.55a1.59,1.59,0,0,1-2.74-1.32l2.84-18.17-18.34-1.28a1.59,1.59,0,0,1-.68-3l16-9.11-10.44-15.14a1.59,1.59,0,0,1,1.9-2.37l17.08,6.8,5.33-17.6a1.58,1.58,0,0,1,3,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M121.62-74.44l2.61,8.6,8.34-3.32A.78.78,0,0,1,133.5-68l-5.1,7.39,7.8,4.45a.78.78,0,0,1-.33,1.45l-9,.62,1.38,8.88a.77.77,0,0,1-1.33.64l-6.08-6.61-6.08,6.61a.77.77,0,0,1-1.33-.64l1.38-8.88-9-.62a.78.78,0,0,1-.33-1.45l7.8-4.45L108.27-68a.77.77,0,0,1,.92-1.16l8.34,3.32,2.61-8.6a.77.77,0,0,1,1.48,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M63.56-8.46l2.6,8.6,8.35-3.32A.77.77,0,0,1,75.43-2L70.34,5.37l7.8,4.45a.78.78,0,0,1-.33,1.45l-9,.62,1.38,8.88a.77.77,0,0,1-1.34.64L62.82,14.8l-6.08,6.61a.77.77,0,0,1-1.33-.64l1.38-8.88-9-.62a.78.78,0,0,1-.33-1.45l7.8-4.45L50.2-2a.78.78,0,0,1,.93-1.16L59.47.14l2.6-8.6a.78.78,0,0,1,1.49,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M176.55-36.7l2.61,8.59,8.34-3.32a.78.78,0,0,1,.93,1.16l-5.1,7.39,7.8,4.45A.78.78,0,0,1,190.8-17l-9,.62,1.38,8.88a.77.77,0,0,1-1.33.64l-6.08-6.61-6.08,6.61a.77.77,0,0,1-1.33-.64l1.38-8.88-9-.62a.78.78,0,0,1-.33-1.45l7.8-4.45-5.1-7.39a.78.78,0,0,1,.93-1.16l8.34,3.32,2.61-8.59a.77.77,0,0,1,1.48,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M121.62,76.29l2.61,8.6,8.34-3.33a.78.78,0,0,1,.93,1.16l-5.1,7.4,7.8,4.45a.77.77,0,0,1-.33,1.44l-9,.63,1.38,8.87a.77.77,0,0,1-1.33.65l-6.08-6.62-6.08,6.62a.77.77,0,0,1-1.33-.65l1.38-8.87-9-.63a.77.77,0,0,1-.33-1.44l7.8-4.45-5.09-7.4a.77.77,0,0,1,.92-1.16l8.34,3.33,2.61-8.6a.77.77,0,0,1,1.48,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M141.77,7l-2.09,6.27-6.61.05a.89.89,0,0,0-.52,1.61l5.31,3.92-2,6.3a.89.89,0,0,0,1.37,1l5.37-3.85L148,26.14a.89.89,0,0,0,1.36-1l-2-6.3,5.32-3.92a.89.89,0,0,0-.52-1.61l-6.61-.05L143.46,7a.89.89,0,0,0-1.69,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "1",
    width: "409.6",
    height: "268.36",
    rx: "7",
    ry: "7",
    fill: "none"
  }));
};

var _default = FlagAU;
exports["default"] = _default;